import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { BYPASS_LOG } from '@constants/app.constant';
import { AuthService } from '@services/auth.service';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
	const authService = inject(AuthService);
	// Skip if request has the BYPASS_LOG context
	if (req.context.get(BYPASS_LOG) || req.url.includes('i18n/')) {
		return next(req);
	}


	// Check if token is valid and present
	if (authService.isLoggedIn() && authService.getToken()) {
		return next(authService.addAuthToken(req));
	} else {
		return authService.refreshToken(req, next).pipe(
			catchError(err => {
				// Qui puoi gestire errori di refresh (es: redirect, logout forzato, notifiche...)
				authService.deleteToken(); // Logout forzato
				// redirect to login? inject Router and do it here
				return throwError(() => err);
			})
		);
	}
};
